import { Produto } from "../../CardProduto/CardProduto";
import styles from "./Itens.module.css";
import X from "../../../assets/X.svg";
import { useTranslation } from "react-i18next";
import { IoIosMore } from "react-icons/io";
import plusIcon from "../../../assets/plusIcon.svg";
import minusIcon from "../../../assets/minusIcon.svg";
import { useEffect, useState } from "react";
import { useCalculateWithFee } from "../../../utils/fee";
import { formatEstimatedDeliveryDate } from "../../../utils/estimatedDeliveryDate";
import noImage from '../../../assets/no-image.jpg'

export interface ProdutoItemProps {
  produto: Produto;
  onRemove?: (id: string) => void;
  onUpdate?: (id: string, qtd: number) => Promise<boolean>;
  amount: number
  hasTopIcon?: boolean;
  entrepreneurView?: boolean;
  screenSize?: number;
  dateDelivery?: Date
  delivery?: "DELIVERY" | "PICKUP"
}

const ProdutoItem = ({
  produto,
  onRemove,
  onUpdate,
  hasTopIcon = false,
  entrepreneurView = false,
  dateDelivery,
  delivery = "DELIVERY",
  amount
}: ProdutoItemProps) => {
  const { id, name, originalPrice, image, brand, quantity, promotionalPrice } = produto;
  const [quantityProduct, setQuantityProduct] = useState<number>(amount);

  useEffect(() => {
    setQuantityProduct(amount);
  }, [amount]);

  const { t, i18n } = useTranslation();
  const calcWithFee = useCalculateWithFee();

  const deliveryDateLabel = formatEstimatedDeliveryDate({
    language: i18n.language,
    referenceDate: dateDelivery ?? new Date(),
    daysFromNow: dateDelivery ? 0 : undefined,
  });

  const handleDecreaseProductQuantity = () => {
    setQuantityProduct((prev) => {
      if(onUpdate){
        onUpdate(id, prev > 1 ? prev - 1 : 1).then((res) => !res && setQuantityProduct(produto.quantidadePedido))
      }
      return (prev > 1 ? prev - 1 : 1)
    });
  };
  const handleIncreaseProductQuantity = () => {
    setQuantityProduct((prev) => {
      if(onUpdate){
        onUpdate(id, prev + 1).then((res) => !res && setQuantityProduct(produto.quantidadePedido))
      }
      return prev + 1
    });

  };
  return (
    <div className={styles.produto_item}>
      <div className={styles.container}>
      <img
                  src={image ?? noImage}
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = noImage;
                  }}
                  className={styles.foto} 
                  alt={name} 
                  />
        <div className={styles.produto_info}>
          <div className={styles.nomeproduto}>
            <h2>{name}</h2>
          </div>

          <div className={styles.main_info_container}>
            <div className={styles.left_info_container}>
              {!entrepreneurView && <p className={styles.nomeloja}>{brand}</p>}
              {entrepreneurView ? (
                <p
                  className={`${styles.retirada}`}
                  style={{ alignSelf: "flex-end" }}
                >
                  {t(`carrinho.pickupInStore`)}
                </p>
              ) : (
                <p className={styles.retirada}>
                  {delivery === "PICKUP"
                    ? t("carrinho.pickupInStoreAtDate")
                    : t("carrinho.withdrawalsAtDate")}{" "}
                  {deliveryDateLabel}
                </p>
              )}
            </div>
            <div className={styles.right_info_container}>
              <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: 'center' }}>
                <span className={styles.precoproduto}>
                  {t("produtoitem.precoproduto")} R$ {promotionalPrice ? calcWithFee(promotionalPrice) : calcWithFee(originalPrice)}
                </span>
                <div className={styles.stockComponentContainer}>
                  <img src={minusIcon} onClick={handleDecreaseProductQuantity} />
                  <input value={quantityProduct} onChange={(e) => {
                    const numb = Number(e.target.value)
                    if (!Number.isNaN(numb))
                      setQuantityProduct(numb)
                  }} onBlur={async () => {
                    if(onUpdate){
                      const res = await onUpdate(id, quantityProduct)
                      if(res) return
                      setQuantityProduct(produto.quantidadePedido)
                    }
                  }} className={styles.inputStock} style={{ backgroundColor: 'white', border: 'white', width: 80, textAlign: 'center' }} />
                  <img src={plusIcon} onClick={handleIncreaseProductQuantity} />
                </div>
              </div>

              {entrepreneurView ? (
                <p className={styles.remainingUnits}>
                  {t(`produtoitem.remainingUnits`)}: {quantity}
                </p>
              ) : (
                <p className={styles.valortotal}>
                  {t("produtoitem.valortotal")}R${" "}
                  {(promotionalPrice ? calcWithFee(promotionalPrice * quantityProduct) : calcWithFee(originalPrice * quantityProduct))} 
                </p>
              )}
            </div>
          </div>
        </div>
        <div className={styles.informacoesproduto}>
          <>
            {hasTopIcon ? (
              <div className={styles.imagem}>
                {" "}
                <IoIosMore
                  size={32}
                  color="#FFF"
                  className={styles.close_icon}
                />{" "}
              </div>
            ) : (
              <div className={styles.imagem}>
                {onRemove && <img
                  src={X}
                  alt="Remover item"
                  className={styles.close_icon}
                  onClick={() => onRemove(id)}
                />}
              </div>
            )}
          </>
        </div>
      </div>
    </div>
  );
};

export default ProdutoItem;
